"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImagePreview = exports.Thumbnail = exports.DND_TYPE_FILEPREVIEW = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var faTrash_1 = require("@fortawesome/pro-solid-svg-icons/faTrash");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importStar(require("react"));
var react_dnd_1 = require("react-dnd");
var FileDropProps_1 = require("./FileDropProps");
var FileUpload_1 = require("./FileUpload");
var PreviewAction_1 = require("./PreviewAction");
var Progress_1 = require("./Progress");
exports.DND_TYPE_FILEPREVIEW = "DND.ImagePreview";
exports.Thumbnail = react_1.default.forwardRef(function (_a, ref) {
    var primary = _a.primary, children = _a.children, props = __rest(_a, ["primary", "children"]);
    return ((0, jsx_runtime_1.jsx)("li", __assign({}, props, { ref: ref, className: (0, clsx_1.default)("border-4", primary ? "border-sorbus-default" : "border-lochivar-dark"), style: {
            minWidth: 110,
        } }, { children: children }), void 0));
});
var Preview = react_1.default.forwardRef(function (_a, ref) {
    var canDrop = _a.canDrop, primary = _a.primary, preview = _a.preview, isDragging = _a.isDragging, connectDragSource = _a.connectDragSource, connectDropTarget = _a.connectDropTarget, uploadURL = _a.uploadURL, onComplete = _a.onComplete, onDelete = _a.onDelete;
    var _b = (0, react_1.useState)(0), progress = _b[0], setProgress = _b[1];
    var _c = (0, react_1.useState)(false), hovering = _c[0], setHovering = _c[1];
    var _d = (0, react_1.useState)(null), hoverTimeout = _d[0], setHoverTimeout = _d[1];
    var _e = (0, react_1.useState)(null), localPreview = _e[0], setLocalPreview = _e[1];
    var _f = (0, react_1.useState)(null), upload = _f[0], setUpload = _f[1];
    var elementRef = (0, react_1.useRef)(null);
    if (!localPreview && preview && preview.file) {
        setLocalPreview(URL.createObjectURL(preview.file));
    }
    if (!upload && preview && preview.file) {
        setUpload((0, FileUpload_1.FileUpload)(preview.id, preview.file, uploadURL, function (id, status, fileProgress) {
            setProgress(fileProgress);
            if (status === FileDropProps_1.FileUploadStatus.Available && onComplete) {
                onComplete(__assign(__assign({}, preview), { status: FileDropProps_1.FileUploadStatus.Available }));
            }
        }));
    }
    (0, react_1.useEffect)(function () { return function () {
        if (localPreview) {
            URL.revokeObjectURL(localPreview);
        }
        if (upload) {
            upload.cancel();
        }
    }; }, [localPreview, upload]);
    connectDragSource(elementRef);
    connectDropTarget(elementRef);
    (0, react_1.useImperativeHandle)(ref, function () { return ({
        getNode: function () { return elementRef.current; },
    }); });
    var opacity = isDragging ? 0.5 : 1;
    var transmitting = preview.status === FileDropProps_1.FileUploadStatus.Pending;
    var deletePreview = function (e) {
        if (onDelete) {
            onDelete(preview);
        }
        e.stopPropagation();
    };
    var toggleHover = function (enabled) { return function () {
        if (hoverTimeout && enabled) {
            clearTimeout(hoverTimeout);
        }
        if (!enabled) {
            setHoverTimeout(setTimeout(function () { return setHovering(enabled); }, 25));
        }
        else {
            setHovering(enabled);
        }
    }; };
    var deleteVisible = !canDrop && hovering ? true : false;
    return ((0, jsx_runtime_1.jsxs)(exports.Thumbnail, __assign({ ref: elementRef, style: { opacity: opacity }, onMouseOver: toggleHover(true), onMouseOut: toggleHover(false), onMouseDown: toggleHover(false), primary: primary }, { children: [onDelete ? ((0, jsx_runtime_1.jsx)(PreviewAction_1.PreviewAction, __assign({ onClick: deletePreview, onMouseOver: toggleHover(true), visible: deleteVisible }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: faTrash_1.faTrash }, void 0) }), void 0)) : ((0, jsx_runtime_1.jsx)("span", {}, void 0)), preview ? ((0, jsx_runtime_1.jsx)("img", { src: localPreview || preview.downloadUrl || "", className: (0, clsx_1.default)(transmitting && "pointer-events-none opacity-20", "flex") }, void 0)) : null, transmitting ? (0, jsx_runtime_1.jsx)(Progress_1.Progress, { progress: progress }, void 0) : null] }), void 0));
});
exports.ImagePreview = (0, react_dnd_1.DropTarget)(exports.DND_TYPE_FILEPREVIEW, {
    hover: function (props, monitor, component) {
        if (!component) {
            return null;
        }
        // node = HTML Div element from imperative API
        var node = component.getNode();
        if (!node) {
            return null;
        }
        var dragIndex = monitor.getItem().index;
        var hoverIndex = props.index;
        // Don't replace items with themselves
        if (dragIndex === hoverIndex) {
            return;
        }
        // Determine rectangle on screen
        var hoverBoundingRect = node.getBoundingClientRect();
        // Get vertical middle
        var hoverMiddle = {
            x: (hoverBoundingRect.right - hoverBoundingRect.left) / 2,
            y: (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2,
        };
        // Determine mouse position
        var clientOffset = monitor.getClientOffset();
        // Get pixels to the top
        var hoverClientX = clientOffset.x - hoverBoundingRect.left;
        // Only perform the move when the mouse has crossed half of the items width
        // When dragging rightwards, only move when the cursor is to the right of 50%
        // When dragging leftwards, only move when the cursor is left of 50%
        // Dragging rightwards
        if (dragIndex < hoverIndex && hoverClientX < hoverMiddle.x) {
            return;
        }
        // Dragging leftwards
        if (dragIndex > hoverIndex && hoverClientX > hoverMiddle.x) {
            return;
        }
        // Time to actually perform the action
        props.onSort(dragIndex, hoverIndex);
        // Note: we're mutating the monitor item here!
        // Generally it's better to avoid mutations,
        // but it's good here for the sake of performance
        // to avoid expensive index searches.
        monitor.getItem().index = hoverIndex;
    },
}, function (connect, monitor) { return ({
    canDrop: monitor.canDrop(),
    connectDropTarget: connect.dropTarget(),
}); })((0, react_dnd_1.DragSource)(exports.DND_TYPE_FILEPREVIEW, {
    beginDrag: function (props) { return ({
        id: props.id,
        index: props.index,
    }); },
    endDrag: function (props) {
        props.onFinishSort();
    },
}, function (connect, monitor) { return ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
}); })(Preview));
